import React from "react";

const SavingThrow = ({ label, value, onChange, onRoll }) => (
  <div className="saving-throw" role="button" tabIndex={0} onClick={(event) => { if (event.target.tagName !== "INPUT") onRoll(); }} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); onRoll(); } }}>
    <label>{label}</label>
    <input value={value} type="number" className="throw-value" min="-10" max="30" onClick={(event) => event.stopPropagation()} onChange={(event) => onChange(Number(event.target.value))} />
  </div>
);

export default SavingThrow;